import {
  GET_REPORT_GRAPH_FAIL,
  GET_REPORT_GRAPH_SUCCESS,
  GET_REPORT_GRAPH_REQUEST,
  GET_CANCER_TYPE_REQUEST,
  GET_CANCER_TYPE_SUCCESS,
  GET_CANCER_TYPE_FAIL,
} from '../Actions/ReportActions.js';
const ReportInitialState = {
  loading: false,
  CancerTypes: [],
  GraphData: [],
};
export const ReportReducer = (state = ReportInitialState, action) => {
  switch (action.type) {
    case GET_REPORT_GRAPH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REPORT_GRAPH_SUCCESS:
      
      return {
        ...state,
        GraphData: action?.payload,
        loading: false,
      };
    case GET_REPORT_GRAPH_FAIL:
      return {
        ...state,
        loading: false,
      };
    case GET_CANCER_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CANCER_TYPE_SUCCESS:
      return {
        ...state,
        CancerTypes: action?.payload,
        loading: false,
      };
    case GET_CANCER_TYPE_FAIL:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
